// Spawn-position + add-shape logic for UmlCanvasToolbar, extracted 2026-07-13
// to keep the toolbar class itself under the ~150-line rule. Functions operate
// on a `toolbar` instance (toolbar.props, toolbar.toolbarRef) — same pattern as
// UmlShapeWidgetBasehandleDragMouseDownHelper.jsx — not a class of their own
// since they need direct access to the toolbar's refs/props.
import { v4 as uuid } from 'uuid';
import umlCanvasEngine from '../../Core/UmlCanvasEngine.js';
import umlViewportEngine from '../../Core/UmlViewportEngine.js';
import UmlPackageShape from '../../Types/UmlPackageShape.js';
import UmlClassShape from '../../Types/UmlClassShape.js';
import UmlCommentShape from '../../Types/UmlCommentShape.js';
import UmlIconShape from '../../Types/UmlIconShape.js';
import UmlCaption from '../../Types/UmlCaption.js';

const STAGGER_OFFSET = 14;
const SPAWN_PADDING = 20;

/**
 * Spawn-point for new shapes: horizontally centered under the toolbar, SPAWN_PADDING
 * below — same formula as UmlCanvas.useViewportInteractions.toWorldPoint (subtract
 * canvasRect, then invert pan/scale).
 * @param {object} toolbar - UmlCanvasToolbar instance
 * @param {number} width
 * @param {number} height
 * @returns {{x: number, y: number}}
 */
export function nextPosition(toolbar, width, height) {
    const canvasRect = toolbar.props.canvasRef.current?.getBoundingClientRect();
    const toolbarRect = toolbar.toolbarRef.current?.getBoundingClientRect();
    const screenCenterX = toolbarRect && canvasRect ? toolbarRect.left + toolbarRect.width / 2 - canvasRect.left : 0;
    const screenTopY = toolbarRect && canvasRect ? toolbarRect.bottom + SPAWN_PADDING - canvasRect.top : 0;
    const worldCenterX = (screenCenterX - umlViewportEngine.panX) / umlViewportEngine.scale;
    const worldTopY = (screenTopY - umlViewportEngine.panY) / umlViewportEngine.scale;
    const n = umlCanvasEngine.shapes.length;
    const stagger = (n % 8) * STAGGER_OFFSET;
    return { x: worldCenterX - width / 2 + stagger, y: worldTopY + stagger };
}

export function handleAddPackage(toolbar) {
    const { x, y } = nextPosition(toolbar, 220, 160);
    umlCanvasEngine.addShape(new UmlPackageShape(uuid(), x, y, 220, 160, 'NewPackage'));
}

export function handleAddClass(toolbar) {
    const { x, y } = nextPosition(toolbar, 180, 100);
    const caption = new UmlCaption(uuid(), 0, 0, 'NewClass', '');
    umlCanvasEngine.addShape(new UmlClassShape(uuid(), x, y, 180, 100, caption));
}

export function handleAddRemarks(toolbar) {
    const { x, y } = nextPosition(toolbar, 160, 80);
    umlCanvasEngine.addShape(new UmlCommentShape(uuid(), x, y, 160, 80, 'New remark'));
}

export function handleAddIconShape(toolbar) {
    const { x, y } = nextPosition(toolbar, 120, 40);
    const caption = new UmlCaption(uuid(), 0, 0, 'NewIcon', '');
    // Default iconKind 'externalSystem' — click the icon itself to change it (or pick 'None'), see UmlIconWidget.jsx.
    umlCanvasEngine.addShape(new UmlIconShape(uuid(), x, y, 120, 40, caption, 'externalSystem'));
}
